import React from 'react';
import moment from 'moment';
import ModalCommon from "../../../ModalCommon";
import ButtonCommon from "../../../ButtonCommon";
import PopupEditNote from "../PopupEditNote/PopupEditNote";
import delIcon from '../../../../assets/delete-24px.svg';
import styles from '../../styles.module.scss';

const Note = ({
                generalNoteID,
                createDate,
                generalNoteStatus,
                dueDate,
                createUserFirstName,
                createUserLastName,
                responsibleUserFirstName,
                responsibleUserLastName,
                freeText,
                onOpen,
                onEdit,
                onDelete
              }) => {
  const popupDeleteMessage = ['האם עליי למחוק מספר עדכון כללי', `${generalNoteID}?`].join(' ');

  const getDateBadge = (value) => {
    return value && (
      <div className={styles.dateBadge}>
        {value}
      </div>
    );
  };

  const cellsArray = [
    {value: generalNoteID},
    {value: getDateBadge(createDate ? moment(createDate).format('DD-MM-YYYY') : '')},
    {value: generalNoteStatus},
    {value: freeText || ''},
    {value: getDateBadge(dueDate ? moment(dueDate).format('DD-MM-YYYY') : '')},
    {value: [createUserFirstName, createUserLastName].filter(Boolean).join(' ')},
    {value: [responsibleUserFirstName, responsibleUserLastName].filter(Boolean).join(' ')},
  ];

  const mapRows = (item, index) => {
    return (
      <div
        key={index}
        className={styles.cell}
      >
        {item.value}
      </div>
    );
  };

  const handleDelete = async () => {
    if (onDelete) {
      await onDelete(generalNoteID);
    }
  };

  return (
    <div className={styles.row}>
      {cellsArray.map(mapRows)}
      <div className={styles.lastCell}>
        <PopupEditNote
          generalNoteID={generalNoteID}
          onEdit={onEdit}
          onOpen={onOpen}
        />
        <ModalCommon
          size={'md'}
          header={popupDeleteMessage}
          customModalTrigger={<ButtonCommon variant={'icon'} icon={delIcon}/>}
          handleAction={handleDelete}
        />
      </div>
    </div>
  );
};

export default Note;